import { EcEnv } from '@castlery/config';
import Script from 'next/script';

const GladlyEnv = EcEnv.NEXT_PUBLIC_APPLICATION_TEST_TAG ? 'STAGING' : 'PROD';

const embedSidekickUrl = () => {
  return GladlyEnv === 'STAGING'
    ? 'https://cdn.gladly.qa/gladly/chat-sdk/widget.js'
    : 'https://cdn.gladly.com/chat-sdk/widget.js';
};

const gladlyConfig = {
  appId: `castlery.com-${EcEnv.NEXT_PUBLIC_COUNTRY.toLocaleLowerCase()}`,
  autoShowButton: false,
};

const embedSidekick = () => {
  return `
	window.gladlyConfig = {
		appId: 'castlery.com-${EcEnv.NEXT_PUBLIC_COUNTRY.toLocaleLowerCase()}',
		autoShowButton: false
	};
  `;
};

const GladlyInitScript = () => {
  return (
    <Script id="gladly-config" strategy="beforeInteractive" dangerouslySetInnerHTML={{ __html: embedSidekick() }} />
  );
};
// const testEmbedSidekick = () => {
//   const embedCode = `
//   window.gladlyConfig = {
//     appId: '${EcEnv.NEXT_PUBLIC_GLADLY_APPID}',
//     autoShowButton: false
//   };
//   !function(c,n,r,t){if(!c[r]){var i,d,p=[];d="PROD"!==t&&t?"STAGING"===t?"https://cdn.gladly.qa/gladly/chat-sdk/widget.js":t:"https://cdn.gladly.com/chat-sdk/widget.js",c[r]={init:function(){i=arguments;var e={then:function(t){return p.push({type:"t",next:t}),e},catch:function(t){return p.push({type:"c",next:t}),e}};return e}},c.__onHelpAppHostReady__=function(t){if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)for(var e=t.init.apply(t,i),n=0;n<p.length;n++){var a=p[n];e="t"===a.type?e.then(a.next):e.catch(a.next)}},function(){try{var t=n.getElementsByTagName("script")[0],e=n.createElement("script");e.async=!0,e.src=d+"?q="+(new Date).getTime(),t.parentNode.insertBefore(e,t)}catch(t){}}()}}(window,document,'Gladly','${GladlyEnv}')`;

//   return embedCode;
// }

interface GladlyLoadScriptProps {
  handleOnLoad?: () => void;
  handleOnReady: () => void;
}

const GladlyLoadScript = ({ handleOnLoad, handleOnReady }: GladlyLoadScriptProps) => {
  return (
    <Script
      id="gladly-script"
      dangerouslySetInnerHTML={{
        __html: `
          window.gladlyConfig = ${JSON.stringify(gladlyConfig)};
          !function(c,n,r,t){
            if(!c[r]){
              var i,d,p=[];
              d="${embedSidekickUrl()}";
              c[r]={init:function(){
                i=arguments;
                var e={then:function(t){return p.push({type:"t",next:t}),e},catch:function(t){return p.push({type:"c",next:t}),e}};
                return e
              }};
              c.__onHelpAppHostReady__=function(t){
                if(delete c.__onHelpAppHostReady__,(c[r]=t).loaderCdn=d,i)
                  for(var e=t.init.apply(t,i),n=0;n<p.length;n++){
                    var a=p[n];
                    e="t"===a.type?e.then(a.next):e.catch(a.next)
                  }
              };
              (function(){
                try{
                  var t=n.getElementsByTagName("script")[0],
                      e=n.createElement("script");
                  e.async=!0;
                  e.src=d+"?q="+(new Date).getTime();
                  t.parentNode.insertBefore(e,t)
                }catch(t){}
              })()
            }
          }(window,document,'Gladly','${GladlyEnv}');
        `,
      }}
      strategy="afterInteractive"
      onLoad={() => {
        if (handleOnLoad) {
          handleOnLoad();
        }
      }}
      onReady={handleOnReady}
    />
  );
};

export { GladlyInitScript, GladlyLoadScript };
